import React, { Fragment, useState } from 'react'
import estilos from './TablaClientesComponent.module.css'
import { useDispatch, useSelector } from 'react-redux'
import {
    ObtenerClientes, obtenerClienteConDetalle, obtenerFC_01PorLogin,
    obtenerSolicitudDetalleFC_01ConMaps
} from '../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import DownloadIcon from '@mui/icons-material/Download';
import { Pagination } from '@mui/material';
import HorizontalRuleRoundedIcon from '@mui/icons-material/HorizontalRuleRounded';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ModalReporteExcelComponent from './ModalReporteExcelComponent';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import BotonReporteExcelComponent from './BotonReporteExcelComponent';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';


function TablaClientesComponent(props) {

    const clientes = useSelector(store => store.ModuloConsulta.clientes)
    const dataUser = useSelector(store => store.Usuario.user)
    const dispatch = useDispatch()

    const [filtroCliente, setFiltrosCliente] = useState(clientes);
    const [currentPage, setCurrentPage] = useState(0);

    const startIndex = currentPage * 9;
    const endIndex = startIndex + 9;
    const [pageCount, setPageCount] = useState(Math.ceil(filtroCliente?.length / 9));
    let [filteredItems, setFilteredItems] = useState(filtroCliente?.slice(startIndex, endIndex));

    const [busqueda, setBusqueda] = useState('');

    const [openModalReporte, setOpenModalReporte] = React.useState(false)

    const [tipoActividades, setTipoActividades] = React.useState([]);

    const handleChangeSelect = async (event) => {
        const { target: { value }, } = event;
        setTipoActividades(value)
        if (value.length > 0) {
            const resultadoFiltrado = await clientes.reduce((resultado, cliente) => {
                if (cliente.actividadcliente.some(actividad => value.includes(actividad.tipoactividad.actividad))) {
                    resultado.push(cliente);
                }
                return resultado;
            }, []);
            setFilteredItems(await sortJSON(resultadoFiltrado, 'numerosocio', 'asc')?.slice(startIndex, endIndex))
            setFiltrosCliente(await sortJSON(resultadoFiltrado, 'numerosocio', 'asc'))
            setPageCount(Math.ceil(resultadoFiltrado?.length / 9))
            setCurrentPage(0);
            setBusqueda('')

        } else {
            setFilteredItems(await sortJSON(clientes, 'numerosocio', 'asc')?.slice(startIndex, endIndex))
            setFiltrosCliente(await sortJSON(clientes, 'numerosocio', 'asc'))
            setPageCount(Math.ceil(clientes?.length / 9))
            setBusqueda('')
        }

    };


    React.useEffect(async () => {
        let res = await dispatch(ObtenerClientes())
        await setFiltrosCliente(res?.payload)
        setPageCount(Math.ceil(res?.payload?.length / 9))

    }, [])

    React.useEffect(async () => {
        setFilteredItems(filtroCliente.slice(startIndex, endIndex))
    }, [currentPage, filtroCliente])

    const handlePageChange = ({ selected }) => {
        setCurrentPage(selected);
    };

    const handleOpenModal = () => {
        setOpenModalReporte(true)
    }
    const handleCloseModal = () => {
        setOpenModal(false)
    }

    const Consulta = async (params) => {
        await dispatch(actualizarLoadingApp_true())
        await dispatch(obtenerClienteConDetalle(params.idcliente))
        //let solicitud = await dispatch(obtenerFC_01PorLogin(params.idlogin))
        //let map = await dispatch(obtenerSolicitudDetalleFC_01ConMaps(solicitud.payload.idfc01_solicitudregistro))
        props.history.push('/ConsultaDetalleOCComponent')
        await dispatch(actualizarLoadingApp_false())
    }

    const handleBuscar = async (textoBuscar) => {
        const busqueda = filtroCliente.filter((item) =>
            item.nombrerazonsocial?.toLowerCase()?.includes(textoBuscar?.toLowerCase()) ||
            item.numerosocio?.toLowerCase()?.includes(textoBuscar?.toLowerCase()) ||
            item.nombrerepresentantelegal?.toLowerCase()?.includes(textoBuscar?.toLowerCase()) ||
            //item.tipocliente.tipocliente.toLowerCase().includes(textoBuscar.toLowerCase()) ||
            item.actividadcliente[0]?.tipoactividad.actividad.toLowerCase().includes(textoBuscar.toLowerCase()) ||
            item.actividadcliente[1]?.tipoactividad.actividad.toLowerCase().includes(textoBuscar.toLowerCase()) ||
            item.actividadcliente[2]?.tipoactividad.actividad.toLowerCase().includes(textoBuscar.toLowerCase()) ||
            item.actividadcliente[3]?.tipoactividad.actividad.toLowerCase().includes(textoBuscar.toLowerCase()) ||
            item.actividadcliente[4]?.tipoactividad.actividad.toLowerCase().includes(textoBuscar.toLowerCase()) ||
            item.actividadcliente[5]?.tipoactividad.actividad.toLowerCase().includes(textoBuscar.toLowerCase())
        );
        setFiltrosCliente(busqueda);
        if (textoBuscar == '') {
            if (tipoActividades.length > 0) {
                const resultadoFiltrado = await clientes.reduce((resultado, cliente) => {
                    if (cliente.actividadcliente.some(actividad => tipoActividades.includes(actividad.tipoactividad.actividad))) {
                        resultado.push(cliente);
                    }
                    return resultado;
                }, []);
                setFilteredItems(await sortJSON(resultadoFiltrado, 'numerosocio', 'asc')?.slice(startIndex, endIndex))
                setFiltrosCliente(await sortJSON(resultadoFiltrado, 'numerosocio', 'asc'))
                setPageCount(Math.ceil(resultadoFiltrado?.length / 9))
                setCurrentPage(0);
            } else {
                setFilteredItems(await sortJSON(clientes, 'numerosocio', 'asc')?.slice(startIndex, endIndex))
                setFiltrosCliente(await sortJSON(clientes, 'numerosocio', 'asc'))
                setPageCount(Math.ceil(await clientes?.length / 9))
                setBusqueda('')
                setCurrentPage(0);

            }
        } else {
            setFilteredItems(await sortJSON(busqueda, 'numerosocio', 'asc')?.slice(startIndex, endIndex))
            //setFiltrosCliente(clientes)
            setCurrentPage(0);
            setPageCount(Math.ceil(busqueda?.length / 9))
        }


    };

    const handleBusquedaChange = (e) => {
        setBusqueda(e.target.value);
        handleBuscar(e.target.value);
    };

    const obtenerEstados = (domiciliosCliente) => {
        const arregloCadena = domiciliosCliente?.map(item => item?.estado || '');

        let estados = '';
        if (domiciliosCliente?.length == 1) {
            estados = arregloCadena[0];
        } else if (arregloCadena?.length > 1) {
            estados = arregloCadena.slice(0, -1).join(', ') + ' y ' + arregloCadena.slice(-1);
        }

        return estados;
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#606060"
            },
            secondary: {
                main: "#EFBF6B"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
        }
    });

    const actividades = [
        'viverista',
        'Productor de maguey',
        'Productor de Mezcal',
        'Envasador',
        'Comercializador de mezcal',
        'Comercializador de bebidas con mezcal'
    ];

    return (
        <Fragment>
            <div className='container2 mt-5 pt-3'>
                {/*<div className="row justify-content-end">
                    <button className="btn btn-outline-success col-4" onClick={() => handleOpenModal()}> <DownloadIcon /> REPORTE DE CLIENTES</button>
                </div>*/}

                <div className="row justify-content-end">
                    <div className={`${dataUser?.[0]?.idrol != 1 ?'col-6 text-end': 'col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'}`} >
                        <ThemeProvider theme={theme}>
                            <FormControl sx={{ m: 1, width: "100%" }} size="small">
                                <InputLabel id="demo-multiple-checkbox-label">Filtro cadena de actividades</InputLabel>
                                <Select
                                    labelId="demo-multiple-checkbox-label"
                                    id="demo-multiple-checkbox"
                                    multiple
                                    value={tipoActividades}
                                    onChange={e => handleChangeSelect(e)}
                                    input={<OutlinedInput label="Filtro cadena de actividades" />}
                                    renderValue={(selected) => selected.join(', ')}
                                >
                                    {actividades.map((actividad) => (
                                        <MenuItem key={actividad} value={actividad} style={{ fontFamily: 'Montserrat' }}>
                                            <Checkbox color='success' checked={tipoActividades.indexOf(actividad) > -1} />
                                            <ListItemText primary={actividad} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </ThemeProvider>
                    </div>
                    {/*<BotonReporteExcelComponent actividadesSeleccionadas={tipoActividades} clientes={clientes}/>*/}
                    {dataUser?.[0]?.idrol == 1 &&
                        <div className={'col-3 col-sm-3 col-md-3 col-lg-3 col-xl-3'} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <button className="btn btn-outline-success" onClick={() => handleOpenModal()} > <DownloadIcon /> Descargar reporte de Excel </button>
                        </div>
                    }

                </div>

                <div className="row mt-3">
                    <input type="text" placeholder="Buscar..." value={busqueda} onChange={handleBusquedaChange} className={`${estilos.buscador}`} />
                </div>

                <div className="row mt-2">
                    {filteredItems?.map((item, index) => (
                        <div key={index} className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-4 mt-3'>

                            <div className={`${estilos.tarjeta}`} onDoubleClick={() => Consulta(item)}>
                                <div className={`${estilos.additional}`}>
                                    <div className={`${estilos.userCard}`}>
                                    </div>
                                    <div className={`${estilos.moreInfo}`}>
                                        <div className='mb-0 text-end' style={{ display: 'flex', justifyContent: 'right' }}><h3 style={{ width: 'fit-content', padding: '1% 3% 1% 3%', backgroundColor: '#2B2B2B', color: 'white' }}>No. {item?.numerosocio}</h3></div>
                                        <h3 className='mb-0 ms-0 mt-0'>Cadena de actividades:</h3>
                                        {item?.actividadcliente?.map((actividad) => (
                                            <p className='ms-3 mb-0'>
                                                <HorizontalRuleRoundedIcon style={{ fill: '#434343' }} />&ensp;{actividad?.tipoactividad?.actividad}</p>
                                        ))}
                                        <h3 className='mb-0 ms-0'>Estado:</h3>
                                        <p className='ms-3'>{obtenerEstados(item?.domiciliofiscalcliente)}</p>
                                    </div>
                                </div>
                                <div className={`${estilos.general}`}>
                                    <div className='mb-0 text-end' style={{ display: 'flex', justifyContent: 'right' }}><h3 style={{ width: 'fit-content', padding: '1% 3% 1% 3%', backgroundColor: '#2B2B2B', color: 'white' }}>No. {item?.numerosocio}</h3></div>
                                    <h3 className='mb-0 ms-0 mt-0'>Nombre o Razón social:</h3>
                                    <p className='ms-3'>{item?.nombrerazonsocial}</p>
                                    <h3 className='mb-0 ms-0'>Tipo de cliente:</h3>
                                    <p className='ms-3'>
                                        {item?.tipocliente?.tipocliente == "No asociado" ? "CLIENTE" :
                                            item?.tipocliente?.tipocliente == "Inscrito" ? "CLIENTE" : item?.tipocliente?.tipocliente.toUpperCase()}
                                    </p>
                                    <h3 className='mb-0 ms-0'>Representante legal:</h3>
                                    <p className='ms-3'>{item?.nombrerepresentantelegal == '' ? '---' : item?.nombrerepresentantelegal}</p>

                                    {/*<button onClick={() => Consulta(item)} className={`btn btn-outline-success`}>Consultar</button>*/}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="row mt-5 pt-3">
                    <ThemeProvider theme={theme}>
                        <Pagination count={pageCount} page={currentPage + 1} onChange={(event, page) => handlePageChange({ selected: page - 1 })}
                            color="secondary" size="large" showFirstButton showLastButton style={{ display: 'flex', justifyContent: 'center' }} />
                    </ThemeProvider>
                </div>
            </div>

            {openModalReporte &&
                <ModalReporteExcelComponent setOpenModalReporte={{ setOpenModalReporte }} setClientes={{ filtroCliente }} actividadesSeleccionadas={tipoActividades} ></ModalReporteExcelComponent>
            }

        </Fragment>
    )
}
function sortJSON(data, key, orden) {
    const copyData = [...data];
    return copyData.sort(function (a, b) {
        var x = a[key],
            y = b[key];

        if (orden === 'asc') {
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }

        if (orden === 'desc') {
            return ((x > y) ? -1 : ((x < y) ? 1 : 0));
        }
    });
}
export default TablaClientesComponent